import React, { Component } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { DEFAULT_DATE_FORMAT } from 'src/ui/const';

import { cleanseInput } from 'src/ui/util';
;
import { Button, Card,
  CardContent,
  Columns,
  Column,
  MuiTitle, } from 'src/ui/mui-ui-kit';;
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form } from 'react-final-form';
import { toast } from 'react-toastify';
import { withNavigation } from 'src/ui/hoc';
import dayjs from 'dayjs-ext';

import {
  setBreadcrumbs,
  reduceServerErrors,
  UiToastAdapter,
  InnerLoader,
} from 'src/ui';
import { getUser } from 'src/user';

import {
  getAccount,
  getSars,
  addLoanSar,
  fetchAccount,
  addAccountLoan,
  updateAccountLoan,
} from 'src/account';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoanEditForm } from '../components';
import { LoanFinancialsForm } from '../components/LoanFinancialsForm';
import { LoanCreditRequestForm } from '../components/LoanCreditRequestForm';
import { LoanDeclarationsNotificationsForm } from '../components/LoanDeclarationsNotificationsForm';
import { LoanSummaryForm } from '../components/LoanSummaryForm';
import { SarsTable } from '../components/SarsTable';
import { SarModal } from '../components/SarModal';

const tabs = [
  {
    id: 'financials',
    label: 'Financials',
    component: LoanFinancialsForm,
    permission: 'user',
  },
  {
    id: 'creditRequest',
    label: 'Credit Request',
    component: LoanCreditRequestForm,
    permission: 'user',
  },
  {
    id: 'declarationsNotifications',
    label: 'Declarations/Notifications',
    component: LoanDeclarationsNotificationsForm,
    permission: 'user',
  },
  {
    id: 'summary',
    label: 'Closed Loan Information',
    component: LoanSummaryForm,
    permission: 'bankAdmin',
  },
];

class LoansEditPage extends Component {
  state = {
    loading: true,
    title: '',
    initialValues: {},
    confirmChangesModal: false,
    activeTab: tabs[0].id,
    showSarModal: false,
  };

  async componentDidMount() {
    const { match, setBreadcrumbs, fetchAccount, getSars } = this.props;
    const { id } = match?.params || {};

    // If we have an id then it's an edit, otherwise adding
    const title = id ? 'Edit' : 'Add';
    this.setState({ title });

    setBreadcrumbs([
      { label: 'Loans', href: '/loans' },
      { label: title, href: match.url },
    ]);

    const { user } = this.props;
    const fiId = user.financialInstitutionId || user.fiSelectedAccountId;
    const account = user.accountId;
    const loan = match.params.id;
    const loanId = parseInt(loan, 10); // Converts loanId string from params to int

    if (fiId) {
      await Promise.all([fetchAccount(user.accountId)]);

      if (id) {
        this.buildData(+id);
      }
    }

    if (user.isBankAdmin && loanId) {
      await Promise.all([getSars(account, loanId)]);
    }

    this.setState({ loading: false });
  }

  handleSubmit = async values => {
    const { match } = this.props;
    const { id } = match.params;

    if (id) {
      return this.updateLoan(id, values);
    }
    return this.addLoan(values);
  };

  showModal = () => {
    this.toggleModal(true);
  };

  hideModal = () => {
    this.toggleModal(false);
  };

  addSar = formValues => {
    const { user, addLoanSar, match } = this.props;
    // eslint-disable-next-line prefer-destructuring
    const accountId = user.accountId;
    const loan = match.params.id;
    const loanId = parseInt(loan, 10); // Converts loanId string from params to int
    const { ...values } = formValues;

    addLoanSar({
      ...values,
      account: accountId,
      loan: loanId,
      sarId: values.sarId,
      sarFilerName: values.sarFilerName,
      sarFiledDate: values.sarFiledDate
        ? dayjs(values.sarFiledDate).format(DEFAULT_DATE_FORMAT)
        : null,
    });

    const { account } = this.props;

    if (account.isError()) {
      return reduceServerErrors(account);
    }

    getSars(account, loanId);

    toast(UiToastAdapter('Sar added', 'success'));

    if (account) {
      this.setState({ showSarModal: false });
    }

    return undefined;
  };

  async addLoan(formValues) {
    const { addAccountLoan, user, history } = this.props;
    const { ...values } = formValues;
    await addAccountLoan({
      ...values,
      accountId: user.accountId,
      loanAnnualSales: values.loanAnnualSales,
      loanBuisnessNetIncome: values.loanBuisnessNetIncome,
      loanBusinessNetEquity: values.loanBusinessNetEquity,
      loanNumberOfEmployees: values.loanNumberOfEmployees,
      loanDecApplicantOblig: values.loanDecApplicantOblig,
      loanDecApplicantTaxesPastDue: values.loanDecApplicantTaxesPastDue,
      loanDecApplicantTaxesPastDueAmt: values.loanDecApplicantTaxesPastDueAmt,
      loanDecApplicantTaxesPastDueOwedTo:
        values.loanDecApplicantTaxesPastDueOwedTo,
      loanDecOtherAssetsPledged: values.loanDecOtherAssetsPledged,
      loanDecOtherCreditPastDue: values.loanDecOtherCreditPastDue,
      loanDecApplicantFelon: values.loanDecApplicantFelon,
      loanDecApplicantPolitical: values.loanDecApplicantPolitical,
      loanDecApplicantPoliticalNameOfEmployee:
        values.loanDecApplicantPoliticalNameOfEmployee,
      loanDecApplicantEmployeeOfBank: values.loanDecApplicantEmployeeOfBank,
      loanDecApplicantEmployeeOfBankEmployee:
        values.loanDecApplicantEmployeeOfBankEmployee,
      loanDecApplicantFinInstEmployee: values.loanDecApplicantFinInstEmployee,
      loanDecApplicantFinInstEmployeeFi:
        values.loanDecApplicantFinInstEmployeeFi,
      loanDecWillFiftyComeFromLease: values.loanDecWillFiftyComeFromLease,
      loanDecWillFiftyComeFromSale: values.loanDecWillFiftyComeFromSale,
      loanType: values.loanType ? values.loanType.value : 'Line of Credit',
      loanAmount: values.loanAmount,
      loanPaymentAmount: values.loanPaymentAmount,
      loanRepaymentPeriod: values.loanRepaymentPeriod,
      loanUseOfFunds: values.loanUseOfFunds,
      loanClosedDate: values.loanClosedDate
        ? dayjs(values.loanClosedDate).format(DEFAULT_DATE_FORMAT)
        : null,
    });

    const { account } = this.props;

    if (account.isError()) {
      return reduceServerErrors(account);
    }

    toast(UiToastAdapter('Loan added', 'success'));

    history.push('/loans');

    return undefined;
  }

  async updateLoan(id, formValues) {
    const { updateAccountLoan, user, history } = this.props;
    const { ...values } = formValues;

    await updateAccountLoan({
      ...values,
      accountId: user.accountId,
      loanId: id,
      loanAnnualSales: values.loanAnnualSales,
      loanBuisnessNetIncome: values.loanBuisnessNetIncome,
      loanBusinessNetEquity: values.loanBusinessNetEquity,
      loanNumberOfEmployees: values.loanNumberOfEmployees,
      loanDecApplicantOblig: values.loanDecApplicantOblig,
      loanDecApplicantTaxesPastDue: values.loanDecApplicantTaxesPastDue,
      loanDecApplicantTaxesPastDueAmt: values.loanDecApplicantTaxesPastDueAmt,
      loanDecApplicantTaxesPastDueOwedTo:
        values.loanDecApplicantTaxesPastDueOwedTo,
      loanDecOtherAssetsPledged: values.loanDecOtherAssetsPledged,
      loanDecOtherCreditPastDue: values.loanDecOtherCreditPastDue,
      loanDecApplicantFelon: values.loanDecApplicantFelon,
      loanDecApplicantPolitical: values.loanDecApplicantPolitical,
      loanDecApplicantPoliticalNameOfEmployee:
        values.loanDecApplicantPoliticalNameOfEmployee,
      loanDecApplicantEmployeeOfBank: values.loanDecApplicantEmployeeOfBank,
      loanDecApplicantEmployeeOfBankEmployee:
        values.loanDecApplicantEmployeeOfBankEmployee,
      loanDecApplicantFinInstEmployee: values.loanDecApplicantFinInstEmployee,
      loanDecApplicantFinInstEmployeeFi:
        values.loanDecApplicantFinInstEmployeeFi,
      loanDecWillFiftyComeFromLease: values.loanDecWillFiftyComeFromLease,
      loanDecWillFiftyComeFromSale: values.loanDecWillFiftyComeFromSale,
      loanType: values.loanType.label,
      loanAmount: values.loanAmount,
      loanPaymentAmount: values.loanPaymentAmount,
      loanRepaymentPeriod: values.loanRepaymentPeriod,
      loanUseOfFunds: values.loanUseOfFunds,
      loanClosedDate: values.loanClosedDate
        ? dayjs(values.loanClosedDate).format(DEFAULT_DATE_FORMAT)
        : null,
    });

    const { account } = this.props;

    if (account.isError()) {
      return reduceServerErrors(account);
    }

    toast(UiToastAdapter('Loan updated', 'success'));
    history.push('/loans');
    return undefined;
  }

  buildData(id) {
    const { account } = this.props;
    // +id returns numeric expression of id in javascript
    const loan = account.loans.find(element => element.id === +id);
    if (loan) {
      const initialValues = {
        ...loan,
        loanType: { value: loan.loanType, label: loan.loanType },
        loanClosedDate: loan.loanClosedDate
          ? dayjs(loan.loanClosedDate)
              .utc()
              .toDate()
          : null,
      };

      this.setState({ initialValues });
    }
  }

  toggleModal(value) {
    this.setState({ confirmChangesModal: value });
  }

  render() {
    const { isExpanded } = this.props;
    const {
      title,
      initialValues,
      loading,
      confirmChangesModal,
      activeTab,
      showSarModal,
      loanDecApplicantTaxesPastDue,
      loanDecApplicantPolitical,
      loanDecApplicantEmployeeOfBank,
      loanDecApplicantFinInstEmployee,
    } = this.state;

    const { user, match } = this.props;
    const loan = match.params.id;
    return (
      <>
        <MuiTitle isSize="4" hasTextColor="info" tag="h2">
          {`${title} Loan`}
          <NavLink
            className="close-page button is-small is-text is-pulled-right"
            to="/loans"
          >
            <span className="icon has-text-danger">
              <FontAwesomeIcon icon={['fal', 'times-circle']} size="2x" />
            </span>
          </NavLink>
        </MuiTitle>
        <Form
          onSubmit={this.handleSubmit}
          subscription={{
            values: {
              loanDecApplicantTaxesPastDue,
              loanDecApplicantPolitical,
              loanDecApplicantEmployeeOfBank,
              loanDecApplicantFinInstEmployee,
            },
            submitting: true,
            dirty: true,
            hasValidationErrors: true,
            dirtySinceLastSubmit: true,
          }}
          initialValues={initialValues}
          mutators={{
            cleanse: ([event, cleansing], state, { changeValue }) => {
              cleanseInput(event, state, changeValue, cleansing);
            },
          }}
          render={({
            handleSubmit,
            submitting,
            hasValidationErrors,
            dirty,
            dirtySinceLastSubmit,
            values,
            form,
          }) => {
            const { account } = this.props;
            const setActiveTab = tab => {
              this.setState({ activeTab: tab });
            };
            return (
              <>
                <Card>
                  <CardContent>
                    <LoanEditForm
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                      tabs={tabs}
                      onSubmit={handleSubmit}
                      submitting={submitting}
                      hasValidationErrors={hasValidationErrors}
                      isDirty={dirtySinceLastSubmit || dirty}
                      isExpanded={isExpanded}
                      values={values}
                      form={form}
                      confirmChangesModal={confirmChangesModal}
                      user={user}
                    />
                  </CardContent>
                  <InnerLoader visible={loading || submitting} />
                </Card>
                <br />
                {activeTab === 'summary' && loan && (
                  <>
                    <Columns isMultiline>
                      <Column isSize="1/2">
                        <MuiTitle isSize="4" hasTextColor="info" tag="h2">
                          SAR History
                        </MuiTitle>
                      </Column>
                      <Column isSize="1/2">
                        <div className="buttons is-right">
                          <Button
                            isColor="gradient-bright"
                            onClick={() =>
                              this.setState({ showSarModal: true })
                            }
                          >
                            <span className="icon">
                              <FontAwesomeIcon icon={['fal', 'plus']} />
                            </span>
                            <span>SAR</span>
                          </Button>
                        </div>
                      </Column>
                    </Columns>
                    <SarsTable loading={loading} sars={account.sars || []} />
                    {showSarModal && (
                      <SarModal
                        open={showSarModal}
                        onClose={() => this.setState({ showSarModal: false })}
                        user={this.props.user}
                        addSar={this.addSar}
                      />
                    )}
                  </>
                )}
              </>
            );
          }}
        />
      </>
    );
  }
}

LoansEditPage.propTypes = {
  match: propTypes.object.isRequired,
  history: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  account: propTypes.object.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  fetchAccount: propTypes.func.isRequired,
  getSars: propTypes.func.isRequired,
  addLoanSar: propTypes.func.isRequired,
  addAccountLoan: propTypes.func.isRequired,
  updateAccountLoan: propTypes.func.isRequired,
  isExpanded: propTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
    account: getAccount(state),
    sars: getSars(state),
  };
}

// Connect the component to Redux
const ConnectedLoansEditPage = connect(
  mapStateToProps,
  {
    setBreadcrumbs,
    fetchAccount,
    getSars,
    addLoanSar,
    addAccountLoan,
    updateAccountLoan,
  }
)(withNavigation(LoansEditPage));

// Wrapper component to provide route params to class component
function LoansEditPageWrapper(props) {
  const params = useParams();
  // Create a component with both the props and the route params
  return <ConnectedLoansEditPage {...props} match={{ params }} />;
}

export { LoansEditPageWrapper as LoansEditPage };
